import { render, staticRenderFns } from "./dividendInfo.vue?vue&type=template&id=57a29b03&scoped=true"
import script from "./dividendInfo.vue?vue&type=script&lang=js"
export * from "./dividendInfo.vue?vue&type=script&lang=js"
import style0 from "./dividendInfo.vue?vue&type=style&index=0&id=57a29b03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a29b03",
  null
  
)

export default component.exports